import { useStoredState } from '@/hooks';
import { useAuth } from '../auth';
import { CalendarFilter, CalendarPanel } from '../calendar';
import { useDoctor } from '../doctors';
import { RecentPatients } from '../patients';
import { useClinicSettings } from '../settings';
import { HOME_TAB_KEY, type HomeTab, HomeTabs } from './HomeTabs';

/**
 * Recent patients on the left, the week's bookings on the right. On a phone
 * they are two tabs, bookings first, with the doctor filter beside them (the
 * top bar has no room for it there).
 */
export function HomePage() {
  const { user } = useAuth();
  const { all, doctorId, filter } = useDoctor();
  const clinic = useClinicSettings(user?.clinic?.id ?? '');
  const [tab, setTab] = useStoredState<HomeTab>(HOME_TAB_KEY, 'bookings');
  return (
    <div className="home">
      <HomeTabs value={tab} onChange={setTab}>
        {tab === 'bookings' && <CalendarFilter className="home__filter" />}
      </HomeTabs>
      <div className={`home__left ${tab === 'patients' ? '' : 'home__pane--off'}`}>
        <RecentPatients />
      </div>
      <div className={`home__right ${tab === 'bookings' ? '' : 'home__pane--off'}`}>
        <CalendarPanel clinic={clinic} doctors={all} doctorId={doctorId} filter={filter} />
      </div>
    </div>
  );
}
